/* ── Tres comportamentos da PDP que o clone nao trouxe ────────────────────
   1. A LEGENDA da opcao mostra o valor escolhido. A referencia escreve
      `Size: Carry-On` e `Color Grey` — o nome da opcao (com dois pontos ou
      sem, como esta no catalogo) mais um espaco e o valor. O Horizon escreve
      so o nome, e nao atualiza ao escolher.
   2. O botao de compra das SECOES CLONADAS (`.main-product-atc` fora do
      formulario) nao fazia nada: o script da secao de origem, que o ligava ao
      formulario de verdade, nao vem no clone. Aqui o clique dele passa a
      acionar o botao de compra real — inclusive a ponte do widget de ofertas.
   3. A GALERIA acompanha a variante. No Vacuum Kit cada pack e uma variante
      com a sua foto; o widget troca o `[name=id]` do formulario, mas a galeria
      do Horizon ouve o seletor dela, nao o campo. A referencia troca a imagem
      ao escolher o pack. */
(function () {
  'use strict';
  if (window.EwcPdp) return;
  window.EwcPdp = true;

  /* nome do arquivo sem caminho, sem query e sem o sufixo de tamanho */
  function limpar(u) {
    var n = String(u || '').split('?')[0].split('/').pop();
    return n.replace(/_(\d+)?x(\d+)?(_crop_[a-z]+)?(\.[a-z0-9]+)$/i, '$4').toLowerCase();
  }

  /* ── 1. legenda com o valor escolhido ─────────────────────────────────── */
  function legendas() {
    document.querySelectorAll('fieldset.variant-option').forEach(function (fs) {
      var leg = fs.querySelector('legend');
      if (!leg) return;

      var marcado = fs.querySelector('input[type=radio]:checked');
      var sel = fs.querySelector('select');
      var valor = marcado ? marcado.value : (sel ? sel.value : '');
      if (!valor) return;

      /* o nome da opcao ja vem no proprio campo; o texto original da legenda e
         a reserva para quando nao vier */
      var nome = leg.getAttribute('data-ewc-nome');
      if (nome == null) {
        nome = (marcado && marcado.getAttribute('data-option-name')) ||
               (leg.textContent || '').trim();
        leg.setAttribute('data-ewc-nome', nome);
      }

      var novo = nome + ' ' + valor;
      if ((leg.textContent || '').trim() !== novo) leg.textContent = novo;
    });
  }

  /* ── 2. botao de compra das secoes clonadas ───────────────────────────── */
  function botaoReal() {
    return document.querySelector('form[action*="/cart/add"] button[name="add"]') ||
           document.querySelector('form[action*="/cart/add"] [type="submit"]');
  }

  function ligarBotoesClonados() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.main-product-atc');
      if (!b) return;
      if (b.closest('form[action*="/cart/add"]')) return;   /* esse e o de verdade */
      var real = botaoReal();
      if (!real || real === b) return;
      e.preventDefault();
      real.click();
    }, true);
  }

  /* ── 3. galeria acompanha a variante do formulario ────────────────────── */
  /* Trocar o `[name=id]` na mao nao basta: a galeria do Horizon ESCONDE as
     fotos das outras variantes (no Vacuum Kit a fita de miniaturas vai da 01
     para a 04, sem a 02 e a 03), entao nao ha miniatura para clicar. Quem sabe
     trocar tudo — foto, preco, endereco — e o seletor do proprio tema. Ele
     esta escondido pelo widget, mas continua na pagina: marcar o radio da
     variante escolhida faz o tema reagir como se o visitante tivesse clicado. */
  function galeriaSegueVariante() {
    var campo = document.querySelector('form[action*="/cart/add"] [name="id"]');
    var no = document.querySelector('[data-ewc-bundle-config]');
    if (!campo || !no) return;

    var porId = {};
    try {
      var d = JSON.parse(no.textContent);
      ((d.produto || {}).variantes || []).forEach(function (v) { porId[String(v.id)] = v; });
    } catch (e) { return; }

    function marcar() {
      var id = String(campo.value);
      var v = porId[id];
      if (!v) return;

      /* caminho direto: o Horizon escreve `data-variant-id` em cada opcao */
      var exato = document.querySelector('fieldset.variant-option input[data-variant-id="' + id + '"]');
      if (exato) {
        if (exato.checked) return;
        exato.click();
        return;
      }
      /* reserva: casa valor por valor das opcoes da variante */
      var valores = v.opcoes || [];
      var campos = document.querySelectorAll('fieldset.variant-option');
      for (var k = 0; k < campos.length && k < valores.length; k++) {
        var r = campos[k].querySelector('input[type=radio][value="' + String(valores[k]).replace(/"/g, '\\"') + '"]');
        if (r && !r.checked) r.click();
      }
    }

    campo.addEventListener('change', marcar);
  }

  /* ── 4. o selo de desconto do preco ───────────────────────────────────
     Dois acertos medidos contra a referencia:

     a) A CONTA. O Horizon arredonda para o mais proximo e a referencia corta
        para baixo: no travesseiro (39 de 59 = 33,9%) ela escreve SAVE 33% e a
        replica escrevia SAVE 34%; no under seat (139 de 230 = 39,6%), 39
        contra 40. Aqui o numero e recalculado da variante escolhida com piso.

     b) ONDE ELE APARECE. Na referencia a PDP com widget de ofertas nao tem
        selo ao lado do preco — quem manda na area de preco e o bundle. A
        replica mostrava os dois. */
  function selo() {
    var caixa = document.querySelector('.price__badge-custom, .price__badge-sale');
    if (!caixa) return;

    /* PDP com bundle de QUANTIDADE (Buy 1 / Buy 2): a referencia nao poe
       selo ao lado do preco, porque quem manda na area de preco e o widget.
       Onde a barra E a variante (1 Pack / 2 Pack / 4 Pack do Vacuum Kit), ela
       mantem o selo — entao a conta abaixo continua valendo. */
    var no = document.querySelector('[data-ewc-bundle-config]');
    if (no) {
      var barraEhVariante = false;
      try {
        var cfg = JSON.parse(no.textContent).cfg || {};
        barraEhVariante = (cfg.barras || []).some(function (b) { return b && b.variante != null; });
      } catch (e) { }
      if (!barraEhVariante) {
        /* a referencia (2026-10-14) mostra o selo ao lado do preco mesmo com
           o widget Buy 1 / Buy 2: mantem o texto escrito no bloco. */
        return;
      }
    }

    var campo = document.querySelector('form[action*="/cart/add"] [name="id"]');
    fetch(location.pathname.replace(/\/$/, '') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants) return;
        function pintar() {
          var id = campo && campo.value;
          var v = p.variants.filter(function (x) { return String(x.id) === String(id); })[0] || p.variants[0];
          if (!v || !v.compare_at_price || v.compare_at_price <= v.price) return;
          var pct = Math.floor((1 - v.price / v.compare_at_price) * 100);
          /* troca so o numero, para nao levar embora o icone do selo */
          var andar = document.createTreeWalker(caixa, NodeFilter.SHOW_TEXT);
          var no;
          while ((no = andar.nextNode())) {
            if (/\d+\s*%/.test(no.nodeValue)) {
              var novo = no.nodeValue.replace(/\d+(\s*)%/, pct + '$1%');
              if (no.nodeValue !== novo) no.nodeValue = novo;
              return;
            }
          }
        }
        pintar();
        if (campo) campo.addEventListener('change', pintar);
        document.addEventListener('change', function (e) {
          if (e.target && e.target.closest && e.target.closest('fieldset.variant-option')) window.setTimeout(pintar, 120);
        }, true);
      }).catch(function () { });
  }


  /* ── 5. selo SAVE na barra de compra fixa ─────────────────────────────────
     A referencia mostra "SAVE n%" ao lado do preco da barra, com o mesmo
     piso do selo do preco (39,6% vira 39). */
  function seloBarra() {
    var preco = document.querySelector('.sticky-add-to-cart__price');
    if (!preco || preco.querySelector('.ewc-sticky-badge')) return;
    function num(el) { return el ? parseFloat(el.textContent.replace(/[^0-9.]/g, '')) : NaN; }
    var venda = num(preco.querySelector('.price-item__group:not(.compare-at-price) bdi, .price-item__group bdi'));
    var cheio = num(preco.querySelector('.compare-at-price bdi'));
    if (!(venda > 0) || !(cheio > venda)) return;
    var s = document.createElement('span');
    s.className = 'ewc-sticky-badge';
    s.textContent = 'SAVE ' + Math.floor((1 - venda / cheio) * 100) + '%';
    preco.appendChild(s);
  }


  /* ── 6. "Ships by": amanha, sempre ────────────────────────────────────────
     A referencia calcula no servidor (hoje + 1 dia). Os snippets daqui sao
     texto fixo, entao a data envelhecia (ficou "Sat, 10 Oct"). */
  function dataEnvio() {
    var alvo = document.querySelectorAll('.vb-ships-bar__text strong');
    if (!alvo.length) return;
    var d = new Date(Date.now() + 86400000);
    var txt = d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }).replace(/\./g, '').replace(' ', ', ');
    for (var i = 0; i < alvo.length; i++) if (/^[A-Z][a-z]{2}, \d+ [A-Z][a-z]{2}$/.test(alvo[i].textContent.trim())) alvo[i].textContent = txt;
  }

  /* ── ligacao ──────────────────────────────────────────────────────────── */
  function iniciar() {
    try { legendas(); } catch (e) { /* uma coisa nao derruba a outra */ }
    try { seloBarra(); } catch (e) { }
    try { dataEnvio(); } catch (e) { }
    try { ligarBotoesClonados(); } catch (e) { }
    try { galeriaSegueVariante(); } catch (e) { }
    try { selo(); } catch (e) { }

    /* o Horizon redesenha o seletor a cada troca de variante: a legenda tem
       de ser reescrita depois disso */
    var alvo = document.querySelector('product-information, .product-information, .product-details') || document.body;
    var pendente;
    new MutationObserver(function () {
      window.clearTimeout(pendente);
      pendente = window.setTimeout(function () { try { legendas(); } catch (e) { } }, 60);
    }).observe(alvo, { childList: true, subtree: true, attributes: true, attributeFilter: ['checked', 'data-current-checked', 'aria-checked'] });

    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('fieldset.variant-option')) legendas();
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
